module.exports = __webpack_public_path__ + "static/images/containers/ChallengesResults/images/ribbon.229d73be.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ChallengesResults/images/ribbon.png
// module id = 2881
// module chunks = 11